import React from "react";
import { Box } from "@mui/material";

const rubikfont = {
  fontFamily: "Rubik, sans-serif",
};

/**
 * Reusable Animated Button Component
 *
 * Props:
 * - text: string → button label
 * - overlayColor: string → hover background (default: black)
 * - textColor: string → default text color
 * - hoverTextColor: string → text color on hover
 * - onClick: function → click handler
 */
export default function AnimatedButton({
  text = "BUTTON",
  overlayColor = "black",
  textColor = "#18181a",
  hoverTextColor = "white",
  onClick = () => {},
}) {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: "relative",
        overflow: "hidden",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        border: `1px solid ${textColor}`,
        color: textColor,
        backgroundColor: "#fff",
        px: 5,
        py: 2.2,
        fontSize: "14px",
        fontWeight: 600,
        letterSpacing: "2px",
        cursor: "pointer",
        userSelect: "none",
        transition: "all 0.3s ease",
        textTransform: "uppercase",
        ...rubikfont,

        "& span": {
          position: "relative",
          zIndex: 10,
          transition: "color 600ms cubic-bezier(0.48, 0, 0.12, 1)",
        },

        "&::after": {
          content: '""',
          position: "absolute",
          bottom: "-50%",
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: overlayColor,
          transformOrigin: "bottom center",
          transform: "skewY(9.3deg) scaleY(0)",
          transition: "transform 600ms cubic-bezier(0.48, 0, 0.12, 1)",
          zIndex: 5,
        },

        "&:hover::after": {
          transform: "skewY(9.3deg) scaleY(2)",
        },

        "&:hover span": {
          color: hoverTextColor,
        },
      }}
    >
      <span>{text}</span>
    </Box>
  );
}
